var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8813 5.28298C15.8813 5.28298 16.6083 -0.292688 19.363 1.74236C21.2492 3.78331 16.1114 5.48297 16.1114 5.48297L15.8813 5.28298Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.836 5.13807C15.836 5.13807 10.2132 5.09599 11.8974 2.11379C13.6933 -0.00708417 16.0064 4.88535 16.0064 4.88535L15.836 5.13807Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9814 5.72584L13.3089 8.43924",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9814 5.72576L19.2313 8.12489",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.99996L16 18.7742",
    stroke: "currentColor",
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.575C7.75681 9.93824 7.07553 9.29163 6.36667 9.29163C5.21032 9.29163 4.5 10.0019 4.5 11.2166C4.5 12.8208 8 15.7083 8 15.7083C8 15.7083 11.5 12.8208 11.5 11.2166C11.5 10.0019 10.7897 9.29163 9.63333 9.29163C8.92374 9.29163 8.24319 9.93824 8 10.575Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_572_2874",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 9,
    width: 8,
    height: 7
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.575C7.75681 9.93824 7.07553 9.29163 6.36667 9.29163C5.21032 9.29163 4.5 10.0019 4.5 11.2166C4.5 12.8208 8 15.7083 8 15.7083C8 15.7083 11.5 12.8208 11.5 11.2166C11.5 10.0019 10.7897 9.29163 9.63333 9.29163C8.92374 9.29163 8.24319 9.93824 8 10.575Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_572_2874)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 5.5,
    width: 21,
    height: 14,
    rx: 1.5,
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard);
export default __webpack_public_path__ + "static/media/GiftCard.87ac17d3253e491f3c38954a701f7f29.svg";
export { ForwardRef as ReactComponent };